module.exports = __webpack_public_path__ + "static/media/face.38fe3136.png";